export enum MenuLink {
    TIME_ENTRY_LINK = 'Time Entry',
    REPORTING_LINK = 'Reporting'
}

export const MenuItemText = new Map([
    ['/tar', 'Time Entry'],
    ['/reports', 'Reporting'],
    ['/administration', 'Administration'],
    ['/bulktimeentry', 'Bulk Time Entry'],
    ['/splashpage', 'Splash Administration']
]);
